
if(document.querySelectorAll('.accordian_tab_item') != null) {
  document.querySelectorAll('.accordian_tab_item').forEach(function(e){
     e.querySelectorAll('.accorian_item')[0].classList.add("active");
  });
}



  var featuredelem = document.querySelector('.product-slide-wrapper');
  var featuredflkty = new Flickity( featuredelem, {
    cellAlign: 'left',
    contain: true,
    pageDots: true,
    cellSelector: '.product-slide',
    groupCells: true
  });

  var collection_slider = document.querySelector('.collection-slider-grid');
  var collectionflkty = new Flickity( collection_slider, {
    cellAlign: 'center',
    contain: true,
    pageDots: true,
    groupCells: true,
    cellSelector: '.collection-slider-item'
  });

  
  var testimonialelem = document.querySelector('.testimonial_card_lists_wrapp');
  var testimonialflkty = new Flickity( testimonialelem, {
    cellAlign: 'center',
    contain: true,
    pageDots: false,
    groupCells: true,
    cellSelector: '.testimonial_card_list',
    responsive: [
    {
      breakpoint: 767,
      settings: {
        cellAlign: 'left'
      }
    }
  ]
  });


 window.addEventListener('load', (event) => { 
  var WindowUrl = window.location.href;
    if(WindowUrl.includes("tagged/")){
    const TagArray = WindowUrl.split("tagged/");
    var Tag = "#Tag-"+TagArray[1];
    document.querySelector(Tag).scrollIntoView({
          top: 300,
          behavior: 'smooth'
      });
  }
});  

  

  document.addEventListener("DOMContentLoaded", () => {
    if(document.querySelector('.template-product fieldset.product-form__input input:checked') != null){
      if(document.querySelector('fieldset.product-form__input input:checked').checked){
        var cuurentViewer = document.querySelector('[id^="GalleryViewer"]');
        const cuurentMedia = cuurentViewer.querySelector('.product__media-item.is-current-img');
        if(cuurentMedia != null){
          var cuurentSlide = Number(cuurentMedia.getAttribute('data-slick-index'));
          $('.thumbnail-list').slick('slickGoTo', cuurentSlide);
        }

        var filter = $('fieldset.product-form__input input:checked').attr('data-image-cls'); 
        var key = "."+filter;
        var element = $("#slider_fillter_meta");
  
        if(element.hasClass(filter)){
          $('.product__media-list, .thumbnail-list').slick('slickUnfilter');                
          $('.product__media-list, .thumbnail-list').slick('slickFilter',key).slick('refresh');
          $('.product__media-list, .thumbnail-list').slick('slickGoTo', 0);
        }
      }
    }
  });

document.addEventListener('DOMContentLoaded', function(){
  const tabs = document.getElementsByClassName('accordian_tab');
  for(let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', tabSwitch, false);
  }

  function tabSwitch(){
    document.getElementsByClassName('is-active')[0].classList.remove('is-active');
    this.classList.add('is-active');
    document.getElementsByClassName('is-show')[0].classList.remove('is-show');
    const arrayTabs = Array.prototype.slice.call(tabs);
    const index = arrayTabs.indexOf(this);
    document.getElementsByClassName('accordian_tab_item')[index].classList.add('is-show');
  };
}, false);

  var accItem = document.getElementsByClassName('accorian_item');
    var accHD = document.getElementsByClassName('accorian_item_title');
    for (i = 0; i < accHD.length; i++) {
        accHD[i].addEventListener("click",function(e){
          if(e.target.parentElement.classList.contains("active")){
            e.target.parentElement.classList.remove("active");
          }else{
           // removeAll()
            e.target.parentElement.classList.add("active");
          }
        });
    }
  function removeAll(){
    document.querySelectorAll('.accorian_item').forEach(function(e){
      e.classList.remove("active");
    })
  }

var element = document.querySelectorAll('.icon-info');
var popupElement = document.querySelectorAll('.card-information_hover_discription');

for (var i = 0; i < element.length; i++) {
    element[i].addEventListener('click', function (e) {
      this.parentElement.classList.toggle("active")
    });
}
for (var i = 0; i < popupElement.length; i++) {
    popupElement[i].addEventListener('click', function (e) {
      this.parentElement.classList.remove("active")
    });
}

if(document.querySelector('.imgtext-grid-slider-inner') != null){
  var elemlandinggrid = document.querySelector('.imgtext-grid-slider-inner');
  var flktygrid = new Flickity( elemlandinggrid, {
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    cellSelector: '.imgtext-grid-slide',
    pageDots: true
  });
}

const supplement_active = document.querySelectorAll(".supplement_facts_popup");
for (var i = 0; i < supplement_active.length; i++) {
  supplement_active[i].addEventListener('click', function (event) {
    event.preventDefault();
    document.querySelector("body").classList.add("overflow-hidden");
    if (this.classList.contains("subscription_benefits")) {
      document.querySelector(".product__description_popup_1").classList.add("popup_open");
    }
    if (this.classList.contains("supplement_facts")) {
      document.querySelector(".product__description_popup_2").classList.add("popup_open");
    }
  });
}


const colse_popup = document.querySelectorAll(".popup_colse");
for (var i = 0; i < colse_popup.length; i++) {
  colse_popup[i].addEventListener('click', function () {
    document.querySelector("body").classList.remove("overflow-hidden");
    if(document.querySelector(".product__description_popup_1") != null){
      if (document.querySelector(".product__description_popup_1").classList.contains("popup_open")) {
        document.querySelector(".product__description_popup_1").classList.remove("popup_open");
      }
    }
    if(document.querySelector(".product__description_popup_2") != null){
      if (document.querySelector(".product__description_popup_2").classList.contains("popup_open")) {
        document.querySelector(".product__description_popup_2").classList.remove("popup_open");
      }
    }
  });
}

document.onclick = function(e){
const popup_inner_1 = document.getElementById('popup_outer_1')
const popup_inner_2 = document.getElementById('popup_outer_2')
  if(e.target === popup_inner_1){
    document.querySelector("body").classList.remove("overflow-hidden");
    document.querySelector(".product__description_popup_1").classList.remove("popup_open");
  }
  
  if(e.target === popup_inner_2){
    document.querySelector("body").classList.remove("overflow-hidden");
    document.querySelector(".product__description_popup_2").classList.remove("popup_open");
  }
};

//iframe renaming

document.addEventListener('DOMContentLoaded', function() {
    // Function to set unique titles for each iframe
    function setUniqueIframeTitles() {
        // Select all iframes on the page
        var iframes = document.getElementsByTagName('iframe');

        // Loop through each iframe and set a unique title
        for (var i = 0; i < iframes.length; i++) {
            var iframe = iframes[i];
            iframe.title = 'Iframe Bariatric Fusion ' + (i + 1); // Unique title based on index
        }
    }

    // Set unique titles initially
    setUniqueIframeTitles();

    // MutationObserver to handle dynamically added iframes
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.tagName === 'IFRAME') {
                        var iframes = document.getElementsByTagName('iframe');
                        var index = Array.prototype.indexOf.call(iframes, node);
                        node.title = 'Iframe Title ' + (index + 1); // Unique title based on index
                    }
                });
            }
        });
    });

    // Configure and start the observer
    observer.observe(document.body, { childList: true, subtree: true });
});

// $(document).ready(function() {
//   var _array = new Array();
//   $('.product-slide-wrapper .product-slide').each(function( index ) {
//     _array.push($(this).outerHeight())
//     Math.max.apply(Math,_array);
//   });
//   console.log(_array);
//   console.log( Math.max.apply(Math,_array));
//   $('.product-slide-wrapper .flickity-viewport').css('height' , Math.max.apply(Math,_array)+ "px");
//   console.log($('.product-slide-wrapper .flickity-viewport'))
// });